import React, { Component } from "react";
import {
  CardTopCustomer,
  CardTopStoreVisitor,
  CardSellsByDay,
  CardSellsByHour,
  CardSellsByMonth,
  CardSellsTopEmployee,
  CardSellsTopCategories,
  CardAverageTicket,
  CardNewClients,
} from "../components";
import { Row, Col } from "reactstrap";

export default class Dashboard extends Component {
  render() {
    return (
      <div className="animated">
        <Row>
          <Col>
            <CardNewClients />
            <CardTopStoreVisitor />
            <CardAverageTicket />
            <CardTopCustomer />
            <CardSellsByDay />
            <CardSellsByHour />
            <CardSellsByMonth />
            <CardSellsTopEmployee />
            <CardSellsTopCategories />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/Dashboard/Dashboard.js